/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('core/router',['require','marionette','core/engine'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var Marionette = require('marionette');
  var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var Router = Marionette.AppRouter.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    routes: {
      '': 'index',
      ':id': 'load'
    },

    index: function(options)
    {
      ////console.log('Router::index');
      ////console.log(arguments);

      options = options || { };

      Engine.urlParams = options;
    },

    load: function(options)
    {
      this.index({ destination: options });
    }

  /*****************************************************************************************************************///}

  });

  return new Router();

});

